import { Routes } from '@angular/router';
import { insightsAuthGuard } from '@core/guards/insights-auth.guard';
import { AllAssessmentsComponent } from './all-assessments/all-assessments.component';
import { AssessmentDetailComponent } from './assessment-detail/assessment-detail.component';
import { discardLinkDataGuard } from './guards/discard-link-data.guard';
import { NewAssessmentComponent } from './new-assessment/new-assessment.component';

export const assessmentRoutes: Routes = [
  { path: 'assessments', component: AllAssessmentsComponent },
  { path: 'assessment', redirectTo: 'assessments/new', pathMatch: 'full' },
  {
    path: 'assessments/new',
    component: NewAssessmentComponent,
    canActivate: [insightsAuthGuard],
    canDeactivate: [discardLinkDataGuard],
  },
  { path: 'assessment/detail/:assessmentId', redirectTo: 'assessments/detail/:assessmentId', pathMatch: 'full' },
  { path: 'assessments/detail/:assessmentId', component: AssessmentDetailComponent, canActivate: [insightsAuthGuard] },
];
